/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stage_Banner_Warning_TitleInputs */

const en_stage_banner_warning_title = /** @type {(inputs: Stage_Banner_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outstanding Tasks in Current Stage`)
};

const pt_br2_stage_banner_warning_title = /** @type {(inputs: Stage_Banner_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividades Pendentes na Etapa Atual`)
};

/**
* | output |
* | --- |
* | "Outstanding Tasks in Current Stage" |
*
* @param {Stage_Banner_Warning_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const stage_banner_warning_title = /** @type {((inputs?: Stage_Banner_Warning_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stage_Banner_Warning_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stage_banner_warning_title(inputs)
	return pt_br2_stage_banner_warning_title(inputs)
});